import { render, staticRenderFns } from "./PdpImageSwiper.vue?vue&type=template&id=a9d3a9b6&scoped=true&"
import script from "./PdpImageSwiper.vue?vue&type=script&lang=js&"
export * from "./PdpImageSwiper.vue?vue&type=script&lang=js&"
import style0 from "./PdpImageSwiper.vue?vue&type=style&index=0&id=a9d3a9b6&prod&lang=postcss&scoped=true&"
import style1 from "./PdpImageSwiper.vue?vue&type=style&index=1&id=a9d3a9b6&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d3a9b6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShopifyImage: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/ShopifyImage.vue').default,SvgIconZoomIn: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconZoomIn.vue').default,SwiperNav: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/swiper-nav/SwiperNav.vue').default})
